<template>
	<div>
		<div
			id="activity"
			class="tabcontent"
			style="display: block !important"
		>
			<div class="lightBubble absolute">
				<div class="bubbleImage"></div>
				<p class="typewriter">
					<vue-typewriter text="V tem zavihku lahko spremljate število povabil k sodelovanju v anketah, število izpolnjenih anket in vaše stanje točk." />
				</p>
			</div>
			<div class="content wp710">
				<h4>{{ $t("profile.your_complition_survey") }}</h4>
				<ul>
					<li class="flex">
						<div class="col2_3">
							<div class="flex border">
								<span class="icon warpit_icon_offered_survey"></span>
								<span class="invited">{{ $t("profile.invitations") }}: {{ numberOfInvitedProject() }}</span>
							</div>
							<div class="flex">
								<span class="icon warpit_icon_finished_survey"></span>
								<span class="finished">{{ $t("profile.complete") }}: {{ numberOfCompletedProject() }}</span>
							</div>
						</div>
						<!-- <div class="col1_3 flex">
							<div class="progress-bar circular" data-percentage="83">
								<div class="barOverflow">
									<div class="bar" :style="degree"></div>
								</div>
								<span class="percentage">{{ calculateTurn() }}%</span>
								<span>{{ $t("profile.completed") }}</span>
							</div>
						</div> -->
					</li>
					<li class="condition">
						<div class="flex space">
							<h4>{{ $t("profile.points_status") }}</h4>
							<div class="flex">
								<span class="points flex">
									{{ formatNumber(getAvailablePoints(points)) }}
									<span class="icon warpit_icon_loyalty-point"></span>
								</span>
							</div>
						</div>
						<a
							class="join hoverEffect"
							ref="joinButton1"
							v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
							v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
							href
							v-on:click.prevent="showPointsData()"
						>
							<label>{{ $t("profile.check_points") }}</label>
							<span
								class="effect"
								ref="effectButton1"
								v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
							></span>
						</a>
					</li>
					<PointsDetail  v-if="showPoints" v-bind:points="points"></PointsDetail>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import PointsDetail from "./PointsDetail";
import { formatNumber, getAvailablePoints } from '@/helpers.js';
import VueTypewriter from "@/components/VueTypewriter";
import { formUtilsMouseHoverEffect } from '@/utils/form_utils.js';

export default {
	data() {
		return {
			showPoints: false,
			turn: 0,
			topX: 1,
			leftX: 1,
			notCompleted: true,
		};
	},
	computed: {
		degree() {
			this.calculateTurn();
			return { transform: "rotate(" + (45 + this.turn * 1.8) + "deg)" };
		},
		user() {
			return this.$store.getters["user/user"];
		},
		projects() {
			return this.$store.getters["user/projects"];
		},
		invites() {
			return this.$store.getters["user/invites"];
		},
		points() {
			return  this.$store.getters["user/points"].transactions.sort((a, b) =>  new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
		}
	},
	components: {
		VueTypewriter,
		PointsDetail,
	},
	mounted() {
		console.log(this.points);
	},
	methods: {
		formUtilsMouseHoverEffect,

		showPointsData() {
			if (this.points) {
				this.showPoints = !this.showPoints;
			}
		},
		calculateTurn() {
			if (this.numberOfInvitedProject() > 0) {
				this.turn = ((this.numberOfCompletedProject() / this.numberOfInvitedProject()) * 100).toFixed();
			}
			return this.turn;
		},
		numberOfInvitedProject() {
			return this.projects.filter(project => 
				project.qStatus !== "1" && 
				(!project.custom_attributes || !project.custom_attributes.some(attr => attr.value === "usepoints"))
			).length + 1;
		},
		numberOfCompletedProject() {
			return this.$store.getters["user/points"].transactions.filter(transaction => transaction.negative !== -1 && transaction.proj_name !== null).length;
		},
		checkPointsRequest() {
			console.log("checkPointsRequest");
		},
		formatNumber,
		getAvailablePoints
	},
};
</script>

<style>
.modal-backdrop {
	opacity: 0.2 !important;
}
</style>